import PropTypes from 'prop-types';

export const REACH = 'reach';
export const TARGET = 'target';
export const SAFETY = 'safety';

const ADMISSION_LIKELIHOOD_CATEGORIES = [SAFETY, TARGET, REACH];

export const ADMISSION_LIKELIHOOD_CATEGORY_PROP_TYPE = PropTypes.oneOf(
  ADMISSION_LIKELIHOOD_CATEGORIES
);
